import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import BannsStore from '../Stores/Banns';
import dateFormat from 'dateformat';
import { dateFormats } from '../Utilities/LanguageCodes';

let getState = () => ({
  bannsList: BannsStore.getBannsList(3)
});

let formatDate = (value) => {
  if (value != null && value.length > 0 && value !== "<p><br></p>") {
    return dateFormat(value, "dd. mm. yyyy");
  }
  return null;
};

class HomeBannsTile extends Component {
  constructor(props) {
    super(props);
    this.state = getState();
    this.onChange = this.onChange.bind(this);
    dateFormat.i18n = dateFormats[props.language] || dateFormats['cs-CZ'];
  }

  componentDidMount() {
    BannsStore.addChangeListener(this.onChange);
    BannsStore.provideBanns(3);
  }

  componentWillUnmount() {
    BannsStore.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState(getState());
  }

  render() {
    const { bannsList } = this.state;

    const items = bannsList.map((banns, i) => {
      const link = `/ohlasky/${banns.system.codename}`;
      const dateFrom = formatDate(banns.timefrom ? banns.timefrom.value : null);
      const dateTo = formatDate(banns.timeto ? banns.timeto.value : null);
      const dateRange = dateFrom && dateTo ? `${dateFrom} – ${dateTo}` : (dateFrom || dateTo || '');

      return (
        <li key={i} className="hp-tile-banns-item">
          <Link to={link}>{banns.perex.value}</Link>
          {dateRange && <span className="hp-tile-banns-date"> ({dateRange})</span>}
        </li>
      );
    });

    return (
      <div className="hp-tile">
        <h2 className="hp-tile-heading">Nejnovější ohlášky</h2>
        {bannsList.length === 0
          ? <div className="hp-tile-loading">Načítám…</div>
          : <ul className="hp-tile-banns-list">{items}</ul>
        }
        <div className="hp-tile-footer">
          <Link to="/ohlasky">Všechny ohlášky →</Link>
        </div>
      </div>
    );
  }
}

export default HomeBannsTile;
